module.exports = __webpack_public_path__ + "img/renzheng@2x.7e79316a.png";